import React from 'react';
import { Button as NativeButton } from 'react-native';
import { Button as KButton, Icon } from '@ui-kitten/components';
export const Native = NativeButton;
export const Kitten = (props) => {
    const { icon, ...rest } = props;
    return (<KButton {...rest} icon={(style) => <Icon style={style} name={icon}/>}/>);
};
Icon.propTypes = undefined;
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=Button.js.map